import { Box, FormControl, InputLabel, Typography } from '@mui/material';
import { TArgs } from '../../types/policies-types';
import InfoAdornment from '../../components/InputAdornment/InputAdornment';

interface DynamicArgsWrapperProps {
  meta: Partial<TArgs>;
  children: React.ReactElement;
  fullWidth?: boolean;
}
const DynamicArgsWrapper: React.FC<
  React.PropsWithChildren<DynamicArgsWrapperProps>
> = props => {
  const {
    meta: { name, label, tooltip },
    children,
    fullWidth = false,
  } = props;
  return (
    <Box width={fullWidth ? '100%' : undefined} flexWrap='wrap'>
      <Box
        p={1}
        mb={2}
        sx={{
          display: 'inline-flex',
        }}
        gap={1}
        flexDirection='row'>
        {tooltip && <InfoAdornment tooltip={tooltip} />}
        <FormControl size='small'>
          {name && label && (
            <InputLabel htmlFor={name}>
              <Typography variant='body1'>{label}</Typography>
            </InputLabel>
          )}
          {children}
        </FormControl>
      </Box>
    </Box>
  );
};

export default DynamicArgsWrapper;
